"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decode = void 0;
var _env = _interopRequireDefault(require("../env/env"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var decode = exports.decode = function decode(string) {
  return _env.default.isClient ? atob(string) : Buffer.from(string, 'base64').toString();
};